import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aria-label", "accessibilityLabel"];
import React from 'react';
export var Surface = _ref => {
  var {
      'aria-label': ariaLabel,
      accessibilityLabel: ariaLabelDeprecated
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": !(ariaLabel || ariaLabelDeprecated),
    "aria-label": ariaLabel || ariaLabelDeprecated,
    role: "img"
  }, props));
};
//# sourceMappingURL=index.js.map